import { FC } from 'react';
import { useListId, useProfileInsightsQuery } from '../../hooks';
import { useListDetailsContext } from '../../contexts/listDetails';
import { useInsightsBoundaryContext } from '../insightsBoundary';
import { ProfileQueryState, ProfileQueryContext } from './ProfileQueryContext';

export const ProfileQueryContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { startDate, endDate } = useInsightsBoundaryContext();
  const listId = useListId(); // Previously in listDetails from useAngularListSegmentContext
  // get the saved query from the details, not the live query (only required/used for Dynamic lists)
  const { searchQuery } = useListDetailsContext(); // Previously in listDetails from useAngularListSegmentContext

  const insightQueryParam = {
    emailListId: listId,
    searchQuery,
    startDate: startDate?.toISOString(),
    endDate: endDate?.toISOString(),
  };

  const {
    data: profile,
    error: profileError,
    isError: isProfileError,
    isLoading: isProfileLoading,
    refetch: refetchProfile,
  } = useProfileInsightsQuery(insightQueryParam);

  const context: ProfileQueryState = {
    isProfileError,
    profileError,
    isProfileLoading,
    refetchProfile,
    profile,
    ...profile,
  };

  return <ProfileQueryContext.Provider value={context}>{children}</ProfileQueryContext.Provider>;
};
